export const DeviceInfo = {
  IsMobile: (window.innerWidth < window.innerHeight) ? window.innerWidth <= 768 : window.innerHeight <= 768,
  IsPortrait: window.innerWidth < window.innerHeight,
  IsTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
};